export default __webpack_public_path__ + "static/bs-196f41dacec0c785f7c52529dd57b869.webp";